import { Service } from 'typedi';
import { CookieService } from '../../cookie.service';

@Service()
export class CookieConsentService {

    private readonly _ConsentCookieName = 'TrimbleUnity_consent';

    public constructor(private readonly _cookieService: CookieService) {

    }

    public getCookieConsentSetting(): CookieConsentType {
        const value = this._cookieService.getCookie(this._ConsentCookieName, {});
        if (value === 'all') {
            return 'all';
        } else if (value === 'essential') {
            return 'essential';
        }

        return undefined;
    }

    public saveCookieConsentSetting(value: CookieConsentType): void {
        this._cookieService.setCookie({
            Name: this._ConsentCookieName,
            Value: value,
            SameSite: 'strict',
            SecondsToLive: 60 * 60 * 24 * 30, // 30 days
        });
    }
}

export type CookieConsentType = 'all' | 'essential' | undefined;
